import { render, staticRenderFns } from "./plandoctor.vue?vue&type=template&id=0c3e323a&scoped=true&"
import script from "./plandoctor.vue?vue&type=script&lang=js&"
export * from "./plandoctor.vue?vue&type=script&lang=js&"
import style0 from "./plandoctor.vue?vue&type=style&index=0&id=0c3e323a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3e323a",
  null
  
)

export default component.exports